<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="600px"
      content-class="rounded-dialog"
    >
      <v-form ref="OPCRFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">{{ action }} OPCR</div>

                  <div class="dialog-subtitle">
                    Fill in the required information belows
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    label="Workback"
                    outlined
                    v-model="isWorkback"
                    dense
                    class="rounded-lg"
                    color="#6DB249"
                    @change="workBackChanged()"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" v-if="isWorkback">
                  <v-file-input
                    v-model="file"
                    :rules="isWorkback ? [formRules.required] : []"
                    accept="application/pdf"
                    outlined
                    color="#6DB249"
                    dense
                    label="Upload file"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" class="field-spacing">
                  <v-select
                    label="Year"
                    outlined
                    v-model="year"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                    :items="yearList"
                  ></v-select>
                </v-col>
                <v-col cols="12" class="field-spacing" v-if="!isWorkback">
                  <v-autocomplete
                    @change="checkIfHeadIsPresident()"
                    label="Assessed By"
                    v-model="assessed_by_user"
                    :rules="[formRules.required]"
                    :readonly="action == 'View'"
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="user_detailID"
                    color="#93CB5B"
                    :items="recommendingUsersList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col v-if="!isWorkback" cols="12" class="field-spacing">
                  <v-autocomplete
                    label="Final Rating By"
                    v-model="final_rating_by_user"
                    :rules="[formRules.required]"
                    :readonly="action == 'View'"
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="id"
                    color="#93CB5B"
                    :items="usersList"
                  >
                  </v-autocomplete>
                </v-col>

                <!-- <v-col cols="12" v-if="!isWorkback">
                  <v-autocomplete
                    @change="checkIfHeadIsPresident()"
                    :label="isHeadPresident ? 'Final Rating By' : 'Assessed By'"
                    v-model="assessed_by_user"
                    :rules="[formRules.required]"
                    dense
                    :readonly="action == 'View'"
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="user_detailID"
                    color="#93CB5B"
                    :items="recommendingUsersList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col v-if="!isHeadPresident && !isWorkback" cols="12">
                  <v-autocomplete
                    label="Final Rating By"
                    v-model="final_rating_by_user"
                    :rules="!isHeadPresident ? [formRules.required] : []"
                    dense
                    :readonly="action == 'View'"
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="id"
                    color="#93CB5B"
                    :items="usersList"
                  >
                  </v-autocomplete>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="btn-save"
              v-if="action == 'Add'"
              @click="addnew()"
            >
              Add OPCR
            </v-btn>
            <v-btn
              color="#519043"
              class="btn-save"
              v-if="action == 'Update'"
              @click="update()"
            >
              Update OPCR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    action: null,
  },

  data() {
    return {
      id: null,
      dialog: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      yearList: [],
      period: null,
      assessed_by_user: null,
      final_rating_by_user: null,
      isWorkback: false,
      file: null,
      periodFrom: null,
      periodTo: null,
      periodList: [
        {
          val: "1",
          mnth: "January",
        },
        {
          val: "2",
          mnth: "February",
        },
        {
          val: "3",
          mnth: "March",
        },
        {
          val: "4",
          mnth: "April",
        },
        {
          val: "5",
          mnth: "May",
        },
        {
          val: "6",
          mnth: "June",
        },
        {
          val: "7",
          mnth: "July",
        },
        {
          val: "8",
          mnth: "August",
        },
        {
          val: "9",
          mnth: "September",
        },
        {
          val: "10",
          mnth: "October",
        },
        {
          val: "11",
          mnth: "November",
        },
        {
          val: "12",
          mnth: "December",
        },
      ],
      year: null,
      presidentUser: null,
      isHeadPresident: null,
      usersList: [],
      recommendingUsersList: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.loadYear();
        this.loadRecommendingOfficers();
        this.getUsers();
        if (data.id) {
          this.id = data.id;
          this.year = data.year;
        } else {
          this.id = null;
          this.year = null;
        }
      },

      deep: true,
    },
  },

  computed: {
    // getRemainingPeriodList() {
    //   let rem = [];
    //   if (this.periodFrom) {
    //     rem = this.periodList.slice(this.periodFrom);
    //   }
    //   return rem;
    // },
  },

  methods: {
    initialize() {},
    loadRecommendingOfficers() {
      this.axiosCall("/my-direct-head/loadRecommendingOfficers", "GET").then(
        (res) => {
          if (res.data) {
            console.log("recommendingListsss", res.data);
            this.presidentUser = res.data.pres_emp;
            let data = res.data.heads;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.recommendingUsersList = data;

            this.recommending_userID = res.data.heads[0].user_detailID;
            this.checkIfHeadIsPresident();
          }
        },
      );
    },

    checkIfHeadIsPresident() {
      if (this.presidentUser.user_detailID && this.recommending_userID) {
        if (this.presidentUser.user_detailID == this.recommending_userID) {
          this.isHeadPresident = true;
        } else {
          this.isHeadPresident = false;
        }
      }
    },

    getUsers() {
      this.axiosCall("/user-details/getDeanDirAboveUsers", "GET").then(
        (res) => {
          let data = res.data;
          data.forEach((element, i) => {
            data[i].name = this.toTitleCase(element.name);
          });
          this.usersList = data;
          // console.log(res.data);
        },
      );
    },

    // loadYear() {
    //   let d = new Date();

    //   let yr = d.getFullYear() + 1;

    //   for (let i = yr; i >= 2020; i--) {
    //     this.yearList.push(i);
    //   }
    // },
    workBackChanged() {
      this.loadYear();
    },
    loadYear() {
      this.yearList = [];

      const currentYear = new Date().getFullYear();

      let startYear;

      if (this.isWorkback) {
        startYear = currentYear - 1;
      } else {
        startYear = currentYear + 1;
      }

      for (let i = startYear; i >= 2020; i--) {
        this.yearList.push(i);
      }
    },
    closeD() {
      this.eventHub.$emit("closeOPCRDialog", false);
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.OPCRFormref.validate()) {
        let data = {
          isWorkback: this.isWorkback,
          year: this.year,
          assessed_by_user: this.assessed_by_user,
          final_rating_by_user: this.final_rating_by_user,
        };
        console.log(data);
        if (this.isWorkback) {
          let fd = new FormData();
          fd.append("file", this.file);
          fd.append("data", JSON.stringify(data));

          this.axiosCall("/opcr/workback", "POST", fd).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          });
        } else {
          this.axiosCall("/opcr", "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          });
        }
      }
    },

    update() {
      if (this.$refs.OPCRFormref.validate()) {
        let data = {
          period: this.period,
          year: this.year,
        };

        this.axiosCall("/opcr/" + this.id, "PATCH", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>
